import { getCountry, getLanguageFromIsoLocale } from "@/lib/locale/locale-common-utils"

interface StoryblokSwissLocaleSwitchProps {
  isoLocale: string
}

function determineSwitchToLocaleHref(country: string, switchToLocale: string | undefined) {
  const targetLanguage = getLanguageFromIsoLocale(switchToLocale ?? "de-DE")
  let prefix = "/"
  const currentPathWithQueryAndHash = location.href.replace(location.origin, "")
  let resultHref = currentPathWithQueryAndHash

  //console.log(targetLanguage)
  //console.log(switchToLocale)

  console.log("Switch to locale with country: " + country + " and target language: " + targetLanguage)
  if (country ?? "".toLowerCase() === "ch") {
    if ((targetLanguage ?? "".toLowerCase()) === "fr") {
      //  console.log("Target FR -> Add prefix")
      //  console.log(currentPathWithQueryAndHash)

      prefix = "/fr/CHF"
      resultHref = prefix + currentPathWithQueryAndHash
    } else if ((targetLanguage ?? "".toLowerCase()) === "de") {
      //console.log("Target DE -> remove prefix")
      //console.log(currentPathWithQueryAndHash)
      if (currentPathWithQueryAndHash.startsWith("/fr/CHF")) {
        //console.log("Starts with prefix -> removing")
        resultHref = currentPathWithQueryAndHash.replace("/fr/CHF", "")
      }
    }
    //console.log(resultHref)
  }
  return resultHref
}

export default function StoryblokSwissLocaleSwitch({ isoLocale }: StoryblokSwissLocaleSwitchProps) {
  let switchToLocale: string | undefined = undefined
  const country = getCountry(isoLocale)
  if (country === "ch") {
    switchToLocale = getLanguageFromIsoLocale(isoLocale) === "de" ? "fr-ch" : "de-ch"
  }

  return (
    <>
      {switchToLocale && (
        <div className={"flex justify-end lg:ml-8"}>
          <button
            className={"flex items-center justify-between gap-1"}
            onClick={() => {
              location.href =
                document.querySelector(`link[hreflang=${switchToLocale}]`)?.getAttribute("href") ??
                determineSwitchToLocaleHref(country, switchToLocale)
            }}
          >
            <div className="relative aspect-square h-5 rounded-sm bg-red-600">
              <span className="absolute inset-x-[40%] inset-y-[10%] bg-white"></span>
              <span className="absolute inset-x-[10%] inset-y-[40%] bg-white"></span>
            </div>
            <span className={"max-lg:hidden"}>{getLanguageFromIsoLocale(switchToLocale).toUpperCase()}</span>
          </button>
        </div>
      )}
    </>
  )
}
